<template>
  <div class="flex-1 flex relative">
    <input
      ref="searchElement"
      v-model="searchString"
      type="text"
      class="search-box"
      :class="{'something': (searchString !== ''), disabled}"
      :placeholder="placeholder">

    <svg
      v-if="searchString"
      class="cancel-search"
      @click="reset">
      <use :xlink:href="'#cancel-red'"></use>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'SearchBox',
    props: {
      inputValue: {
        type: String,
        required: true
      },
      disabled: Boolean,
      placeholder: {
        type: String,
        default: 'Search job'
      }
    },
    data: () => ({
      searchString: ''
    }),
    mounted () {
      this.searchString = this.inputValue
    },
    methods: {
      reset () {
        this.searchString = ''
        this.$refs.searchElement.focus()
      }
    },
    watch: {
      searchString (val) {
        /* might want to add a little _.debounce at some point */
        this.$emit('input', val)
        // this.$store.commit('prepress/SetJobSearchString', val)
      }
    }
  }
</script>

<style lang="scss" scoped>
.cancel-search {
  position: absolute;
  right: 10px;
  height: $size-grid / 2;
  width: $size-grid / 2;
  top: calc(50% - 22px);
  cursor: pointer;
}
.something {
  background-color: rgba(140, 198, 63, 0.25);
}
.disabled {
  pointer-events: none;
  border-color: $gray-light;
  /*filter: brightness(0) saturate(100%) invert(93%) sepia(8%) saturate(29%) hue-rotate(169deg) brightness(87%) contrast(91%);*/
}
</style>



// WEBPACK FOOTER //
// src/components/basic/SearchBox.vue